export default "__VITE_ASSET__COZ0V8tI__"